import { Injectable } from '@angular/core'

import { Observable, from } from 'rxjs'

import { Persona } from '../models/persona'
import { Mapper } from '../services/mapper.service'
import { Store } from './store'
import { ApiService } from './api.service'
import { map, mergeMap, toArray } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class PersonaService extends Store<Persona> {

  constructor(private api: ApiService) {
    super(new Persona({ }))
  }
  /**
   * Get a persona by ID
   * @param personaId the personaId
   */
  public getPersona(personaId: number): void {
    this.api.get(`v3/households/personas/${personaId}`)
      .subscribe(
        (data: any) => {
          const persona = Mapper.as<Persona>(data.result, Persona)
          this.subject.next(persona)
        }
      )
  }

  public findMerges(mergedPersonaId: number): Observable<any> {
    return this.api.get(`/persona_merges?merged_persona_id=${mergedPersonaId}`)
  }
}
